import gql from "graphql-tag";

// fragment
export const PLANT_SPECIES_FRAGMENT = gql`
    fragment plantSpecies on PlantSpeciesNode {
        id
        name
        updatedAt
        updatedBy
    }
`;

// all query
export const PLANT_SPECIES_QUERY = gql`
    query {
        tenantPlantSpecies {
            edges {
                node {
                    ...plantSpecies
                }
            }
        }
    }
    ${PLANT_SPECIES_FRAGMENT}
`;

// single query
export const SINGLE_PLANT_SPECIES_QUERY = gql`
    query plantSpecies($id: ID!) {
        plantSpecies(id: $id) {
            ...plantSpecies
        }
    }
    ${PLANT_SPECIES_FRAGMENT}
`;

// create
export const CREATE_PLANT_SPECIES_MUTATION = gql`
    mutation createPlantSpecies($input: CreatePlantSpeciesInput!) {
        createPlantSpecies(input: $input) {
            plantSpecies {
                ...plantSpecies
            }
        }
    }
    ${PLANT_SPECIES_FRAGMENT}
`;

// update
export const UPDATE_PLANT_SPECIES_MUTATION = gql`
    mutation updatePlantSpecies($input: UpdatePlantSpeciesInput!) {
        updatePlantSpecies(input: $input) {
            plantSpecies {
                ...plantSpecies
            }
        }
    }
    ${PLANT_SPECIES_FRAGMENT}
`;

// delete
export const DELETE_PLANT_SPECIES_MUTATION = gql`
    mutation deletePlantSpecies($input: DeletePlantSpeciesInput!) {
        deletePlantSpecies(input: $input) {
            plantSpecies {
                ...plantSpecies
            }
        }
    }
    ${PLANT_SPECIES_FRAGMENT}
`;
